export const toUsers = users =>
  users.map(user => ({
    value: user.id,
    label: user.userName
  }))

export const getTotalValue = deals => deals.reduce((acc, deal) => acc + deal.value, 0)

export const toYears = years => {
  return years.map(year => ({
    value: year,
    label: year
  }))
}
